import type { HttpTransport } from '@mangovoice/api-client'

import { createAiConfigurationResource } from './resources/ai-configuration'
import { createAuthResource } from './resources/auth'
import { createBlockedNumbersResource } from './resources/blocked-numbers'
import { createCallsResource } from './resources/calls'
import { createContactsResource } from './resources/contacts'
import { createDevicesResource } from './resources/devices'
import { createExtensionsResource } from './resources/extensions'
import { createFaxesResource } from './resources/faxes'
import { createHotelsResource } from './resources/hotels'
import { createMessagingResource } from './resources/messaging'
import { createMusicOnHoldResource } from './resources/music-on-hold'
import { createPbxLocationsResource } from './resources/pbx-locations'
import { createPbxesResource } from './resources/pbxes'
import { createPhoneNumbersResource } from './resources/phone-numbers'
import { createQueuesResource } from './resources/queues'
import { createReportingResource } from './resources/reporting'
import { createSchedulesResource } from './resources/schedules'
import { createSoundClipsResource } from './resources/sound-clips'
import { createSwitchboardResource } from './resources/switchboard'
import { createSystemSettingsResource } from './resources/system-settings'
import { createUserGroupsResource } from './resources/user-groups'
import { createUsersResource } from './resources/users'
import { createVoicemailsResource } from './resources/voicemails'
import { createVoipProfilesResource } from './resources/voip-profiles'
import { createWebhooksResource } from './resources/webhooks'

export function createMangoApiClient(transport: HttpTransport) {
  return {
    auth: createAuthResource(transport),
    pbxes: createPbxesResource(transport),
    extensions: createExtensionsResource(transport),
    users: createUsersResource(transport),
    phoneNumbers: createPhoneNumbersResource(transport),
    calls: createCallsResource(transport),
    voicemails: createVoicemailsResource(transport),
    faxes: createFaxesResource(transport),
    messaging: createMessagingResource(transport),
    contacts: createContactsResource(transport),
    blockedNumbers: createBlockedNumbersResource(transport),
    switchboard: createSwitchboardResource(transport),
    hotels: createHotelsResource(transport),
    devices: createDevicesResource(transport),
    webhooks: createWebhooksResource(transport),
    schedules: createSchedulesResource(transport),
    soundClips: createSoundClipsResource(transport),
    musicOnHold: createMusicOnHoldResource(transport),
    reporting: createReportingResource(transport),
    aiConfiguration: createAiConfigurationResource(transport),
    userGroups: createUserGroupsResource(transport),
    systemSettings: createSystemSettingsResource(transport),
    pbxLocations: createPbxLocationsResource(transport),
    queues: createQueuesResource(transport),
    voipProfiles: createVoipProfilesResource(transport),
  }
}

export type MangoApiClient = ReturnType<typeof createMangoApiClient>
